// extracted by mini-css-extract-plugin
module.exports = {"fsk":"_6eb00b8e53--fsk--2nC9i"};